export class PwdValidatorRes {
    IsPasswordValid!: boolean;
    ValidationMessage: string[];
}

export class PwdValidatorParam {
    Password!: string;
    OrgId?: number;
}